/* eslint-disable no-use-before-define */
import React, { useState } from 'react'
import useAutocomplete from '@material-ui/lab/useAutocomplete'
import { makeStyles } from '@material-ui/core/styles'
import { Divider } from '@material-ui/core'
import { useSelector } from 'react-redux'

const useStyles = makeStyles((theme) => ({
  label: {
    display: 'block'
  },
  listbox: {
    width: 'calc(100% - 20px)',
    margin: '15px 0px',
    padding: '10px 0',
    // zIndex: 1,
    position: 'absolute',
    listStyle: 'none',
    backgroundColor: 'white',
    overflow: 'unset',

    border: '1px solid #668c98',
    borderRadius: 2,
    [theme.breakpoints.up('md')]: {
      width: 280
    },
    '& li[data-focus="true"]': {
      backgroundColor: '#eefbfc',

      cursor: 'pointer'
    },
    '& li:active': {
      backgroundColor: '#eefbfc'
    },
    '&::before': {
      content: "''",
      display: 'block',
      width: '14px',
      height: '14px',
      position: 'absolute',
      border: 'solid #668c98',
      borderWidth: '1px 0 0 1px',
      backgroundColor: '#fff',
      transform: 'rotate(45deg)',
      top: '-8px',
      left: '20px'
    }
  },
  listItem: {
    padding: '6px 16px 5px'
  },
  itemGroupTag: {
    margin: '6px 16px 5px',
    fontWeight: 600
  },
  divider: {
    margin: '10px 10px'
  },
  errorContainer: {
    margin: '0 10px 10px',
    border: '1px solid #a10000',
    padding: 10,
    background: '#f1d8d6',
    color: '#002f3d',
    fontSize: 14,
    lineHeight: 1.2,
    borderRadius: 2
  },
  errorIcon: {
    position: 'absolute',
    top: 15,
    left: 20,
    fontSize: 16,
    padding: 1,
    border: '2px solid #a10000',
    borderRadius: '50%',
    color: '#a10000',
    lineHeight: '1',
    '&::before': {
      fontFamily: 'nch-icons',
      verticalAlign: 'middle',
      content: '""'
    }
  },
  errorMessage: {
    margin: '0 0 0 32px',
    color: '#002f3d',
    fontSize: '16px',
    fontWeight: 500
  },
  innerOverFlow: {
    overflow: 'auto',
    maxHeight: 400
  }
}))

function CityAutoComplete({ inputProps, options, value, onChange }) {
  const classes = useStyles()
  const [isShowOnClick, setIsShowOnClick] = useState(true)

  // need to use optionsClone to trigger deep compare -> rerender
  const optionsClone = [...options]
  const cityGroupsToShowOnClick = ['Large cities', 'Popular places']

  const strings = useSelector((state) => state.language.text)

  const citiesToShow = optionsClone
    .filter(({ group }) =>
      isShowOnClick
        ? cityGroupsToShowOnClick.some((cityGroup) => cityGroup === group)
        : true
    )
    .map((city) => {
      return {
        ...city,
        // set group to '' to make displaying in when type
        group: isShowOnClick ? city.group : ''
      }
    })
    .sort((a, b) => {
      return a.type === 'city' ? -1 : 1
    })

  const {
    getRootProps,
    getInputLabelProps,
    getInputProps,
    getListboxProps,
    getOptionProps,
    groupedOptions,
    inputValue
  } = useAutocomplete({
    options: citiesToShow,
    getOptionLabel: (option) => option.label,
    groupBy: (option) => {
      return option.group
    },
    value: value,
    onOpen: () => {
      setIsShowOnClick(true)
    },
    onChange: (e, value) => {
      onChange(value)
    },
    onInputChange: (_, value) => {
      if (value === '') {
        setIsShowOnClick(true)
      } else {
        setIsShowOnClick(false)
      }
    },
    getOptionSelected: (option, value) => {
      return option.value === value.value
    },
    filterOptions: (options, state) => {
      const filteredOptions = options.filter(
        ({ label }) =>
          label.toLowerCase().includes(state.inputValue.toLowerCase()) ||
          label.toLowerCase() === state.inputValue.toLowerCase()
      )

      const result =
        filteredOptions.length === 0
          ? optionsClone.filter(({ group }) =>
              cityGroupsToShowOnClick.some((cityGroup) => cityGroup === group)
            )
          : filteredOptions
      return result
    }
  })

  const getOptionIndexMaker = () => {
    let startIndex = 0
    return () => {
      return startIndex++
    }
  }

  const getOptionIndex = getOptionIndexMaker()

  const getAllOptions = (groupedOptions) => {
    return groupedOptions.map(({ options }) => options).flat(2)
  }

  const getGroupLocale = (group) => {
    switch (group) {
      case 'Popular places':
        return strings.popularPlaces
      case 'Large cities':
        return strings.largeCities
      default:
        return ''
    }
  }

  return (
    <div>
      <div {...getRootProps()}>
        <input
          {...getInputProps()}
          {...inputProps}
          autoComplete="off"
          spellcheck="false"
          autocorrect="off"
          placeholder={strings.whereAreYouGoing}
        />
      </div>

      {groupedOptions.length > 0 ? (
        <ul className={classes.listbox} {...getListboxProps()}>
          {getAllOptions(groupedOptions).every(
            ({ label }) =>
              !label.toLowerCase().includes(inputValue.toLowerCase()) &&
              !isShowOnClick
          ) ? (
            <div className={classes.errorContainer}>
              <span className={classes.errorIcon}></span>
              <p className={classes.errorMessage}>{strings.noResultError}</p>
            </div>
          ) : (
            ''
          )}

          {/* view when click */}
          {groupedOptions.every((groupOption) => groupOption.group !== '') &&
            groupedOptions.map(({ key, options, group }, index) => (
              <div key={key === undefined ? '' : key}>
                <div className={classes.itemGroupTag}>
                  <strong>{getGroupLocale(group)} </strong>
                </div>

                <div className={classes.innerOverFlow}>
                  {options.map((option) => (
                    <li
                      key={option.value}
                      className={classes.listItem}
                      {...getOptionProps({
                        option,
                        index: getOptionIndex()
                      })}>
                      {option.label}{' '}
                      {option.count || option.count === 0
                        ? `(${option.count})`
                        : ''}
                    </li>
                  ))}
                  {index !== groupedOptions.length - 1 && (
                    <Divider
                      className={classes.divider}
                      variant="middle"></Divider>
                  )}
                </div>
              </div>
            ))}

          {/* view when type something */}
          {groupedOptions.every((option) => option.group === '') && (
            <div className={classes.innerOverFlow}>
              {groupedOptions[0].options
                .filter((option) => option.type === 'city')
                .map((option) => (
                  <React.Fragment key={option.value}>
                    <div className={classes.innerOverFlow}>
                      <li
                        key={option.value}
                        className={classes.listItem}
                        {...getOptionProps({
                          option,
                          index: getOptionIndex()
                        })}>
                        {option.label}{' '}
                        {option.count || option.count === 0
                          ? `(${option.count})`
                          : ''}
                      </li>
                    </div>
                  </React.Fragment>
                ))}

              {/* show divider when have both city and venue as options */}
              {groupedOptions[0].options.some(
                (option) => option.type === 'city'
              ) &&
                groupedOptions[0].options.some(
                  (option) => option.type === 'venue'
                ) && (
                  <Divider
                    className={classes.divider}
                    variant="middle"></Divider>
                )}

              {groupedOptions[0].options.filter(
                (option) => option.type === 'venue'
              ).length > 0 && (
                <>
                  <div className={classes.itemGroupTag}>
                    <strong>{strings.recommendedVenues}</strong>
                  </div>
                  {groupedOptions[0].options
                    .filter((option) => option.type === 'venue')
                    .map((option) => (
                      <React.Fragment key={option.value}>
                        <div className={classes.innerOverFlow}>
                          <li
                            key={option.value}
                            className={classes.listItem}
                            {...getOptionProps({
                              option,
                              index: getOptionIndex()
                            })}>
                            {option.label}
                          </li>
                        </div>
                      </React.Fragment>
                    ))}{' '}
                </>
              )}
            </div>
          )}
        </ul>
      ) : null}
    </div>
  )
}

export default CityAutoComplete
